/**
 * AutoFilledTag — a small inline chip that marks a form field whose value
 * was populated automatically by ILMU (OCR scan, policy auto-derivation,
 * etc.) rather than typed by the user. Used on the Apply Leave SmartIntake
 * flow when an uploaded MC/birth-cert/wedding-card pre-fills the date or
 * leave-type field.
 *
 * Mirrors prototype/employee.jsx:2437–2454 (`AutoFilledTag`).
 */
export function AutoFilledTag({ source = 'ILMU' }: { source?: string }): JSX.Element {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        padding: '2px 8px',
        fontFamily: 'var(--font-mono)',
        fontSize: 10.5,
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        color: 'var(--ilmu-fg)',
        background: 'var(--pear-tint)',
        border: '1px solid var(--pear)',
        borderRadius: 999,
        lineHeight: 1.4,
      }}
      role="status"
      aria-label={`Auto-filled by ${source}`}
    >
      <span
        aria-hidden="true"
        style={{
          width: 5,
          height: 5,
          borderRadius: '50%',
          background: 'var(--pear)',
        }}
      />
      Auto-filled
    </span>
  )
}
